module.exports = __webpack_public_path__ + "img/Pic_Services-3.6821e77b.jpg";